import { render, staticRenderFns } from "./AddCoparentModal.vue?vue&type=template&id=1b426e0e"
import script from "./AddCoparentModal.vue?vue&type=script&lang=js"
export * from "./AddCoparentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports